export default Object.freeze({
  FROM_GROUP: 'FROM_GROUP',
  TYPICAL_GROUP: 'TYPICAL_GROUP',
  TYPICAL_REGULAR: 'TYPICAL_REGULAR',
});
